import { registerLocaleData } from "@angular/common";
import localeFr from "@angular/common/locales/fr";
import { isDevMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { enableAkitaProdMode } from "@datorama/akita";
import * as Sentry from "@sentry/angular";

import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";

registerLocaleData(localeFr, "fr");

Sentry.init({
    ...environment.sentry,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()]
});

if (!isDevMode()) {
    enableAkitaProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((error: unknown) => {
    console.error(error);
});
